<ng-container *ngIf="{ trialTasks: (trialTasks$ | async) || [] } as obj">
  <div
    class="text-white flex items-center text-sm cursor-pointer px-4"
    cdkOverlayOrigin
    #trigger="cdkOverlayOrigin"
    (click)="toggleOpenList(!isOpen)"
    (auxClickOutside)="toggleOpenList(false)"
    [ngClass]="{ 'bg-aux-gray-light text-aux-blue': isOpen }"
  >
    <span inlineSVG="task.svg" [setSVGAttributes]="{ class: 'w-4 h-4' }"></span>
    <span class="mx-5px">Tasks</span>
    <span
      class="rounded-full text-aux-blue font-bold bg-aux-gray-light border border-aux-blue h-8 w-8 flex justify-center items-center"
      *ngIf="obj.trialTasks.length"
    >
      <span>{{ obj.trialTasks.length }}</span>
    </span>
  </div>

  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="isOpen"
  >
    <ng-container *ngIf="trialTasks$ | async as trialTasks">
      <aux-portfolio-task-list
        [tasks]="trialTasks"
        [noTasksMessage]="noMessage"
        class="bg-white border-l border-aux-gray-dark shadow overflow-y-scroll"
        style="width: 400px; max-height: 420px"
        [ngStyle]="{ height: obj.trialTasks.length ? 'auto' : '420px' }"
      ></aux-portfolio-task-list>
    </ng-container>
  </ng-template>
</ng-container>
